export const otpSecretFromProvisioningUri = uri => {
  if (!uri) return '';

  try {
    return new URL(uri).searchParams.get('secret') || '';
  } catch {
    const match = String(uri).match(/[?&]secret=([^&]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }
};
